(function ($) {
	$(document).ready(function () {
		$('.kc-calendar').datepicker({
			onChangeMonthYear: function () {
				setTimeout(() => {
					kc_place_calendar_points();
				}, 0);
			},
			dayNamesMin: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam']
		});
		kc_place_calendar_points();
	});

	/**
	 * Application des points et liens dans le calendrier
	 *
	 * @return {void}
	 */
	function kc_place_calendar_points() {
		// Prevent default calendar link behavior
		$('td a').click(function (event) {
			event.preventDefault();
			event.stopPropagation();
			if ($(this).attr('href') != '#') window.location.href = $(this).attr('href');
		});

		// Group events by day
		const eventsByDay = {};
		$.each(kc_event_dates, function (index, value) {
			const key = value.year + '-' + value.month + '-' + value.day;

			if (!eventsByDay[key]) eventsByDay[key] = [];

			eventsByDay[key].push(value);
		});

		// Add events to calendar
		$.each(eventsByDay, function (key, events) {
			const firstEvent = events[0];
			if (
				$('td[data-year="' + firstEvent.year + '"]').length > 0 &&
				$('td[data-month="' + firstEvent.month + '"]').length > 0
			) {
				const $dayElement = $('.ui-state-default[data-date="' + firstEvent.day + '"]');
				let eventsHtml = '<div class="kc-events">';

				events.forEach(function (event) {
					eventsHtml += '<div class="kc-event"></div>';
				});
				eventsHtml += '</div>';
				$dayElement.append(eventsHtml);

				// Set link based on number of events
				$dayElement.attr('href', events.length > 1 ? '/evenements/' : firstEvent.link);
			}
		});
	}
})(jQuery);
